import {isNil, isNotEmpty, trim} from 'ramda';

import {VehicleItem} from '../../../types/api/api';

export function getBatchVehicleRecommendedPrice(
  vehicleItem: VehicleItem
): {amount: number; currency: string} | null {
  const pr = vehicleItem.priceReport;
  if (isNil(pr)) {
    return null;
  }
  if (vehicleItem.pricingStatus !== 'priced') {
    return null;
  }
  const currency = pr.currency ?? '';
  if (!isNotEmpty(trim(currency))) {
    return null;
  }
  if (typeof pr.recommendedPrice !== 'number' || !Number.isFinite(pr.recommendedPrice)) {
    return null;
  }
  return {amount: pr.recommendedPrice, currency: trim(currency)};
}
